import { useParams } from "react-router-dom";
import { Button, Form, Input } from "antd";
import { ColumnsType } from "antd/es/table";
import BodyTable from "../../components/GlobalTable/BodyTable";
import { IoIosArrowForward } from "react-icons/io";
import AntTable from "../../components/AntTable/AntTable";

type Props = {};

const StocktakingDetails = (props: Props) => {
  const params = useParams();
  const data = [
    {
      key: "1233",
      id: 103,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 200,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
    {
      key: "1233",
      id: 103,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 200,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
    {
      key: "1234",
      id: 104,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 210,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
    {
      key: "1234",
      id: 104,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 210,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
    {
      key: "1234",
      id: 104,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 210,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
    {
      key: "1231",
      id: 101,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 180,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
    {
      key: "1232",
      id: 102,
      name: "لوريال - بسلم",
      exception: 200,
      Stocktaking: 180,
      teamMember: "هنا احمد",
      dif: 80,
      price: -100,
    },
  ];
  const getStatusStyles = (value: any) => {
    let color = "";
    console.log(value);

    if (value.exception < value.Stocktaking) {
      color = "#479821"; // Change to your desired color for this condition
    } else if (value.exception > value.Stocktaking) {
      color = "#C43535"; // Change to your desired color for this condition
    } else {
      color = "#00086D"; // Change to your desired color when both values are equal
    }

    return color;
  };
  const columns: ColumnsType<any> = [
    {
      title: <div className="bg-[#eef0ff] w-full h-full py-1">اسم المنتج</div>,
      render: (text: any, record: any) => {
        const color = getStatusStyles(record);
        return (
          <div
            className={` py-4 !border-l-0 min-w-[150px]  bg-white !pt-[15px] w-full h-full text-color-primary text-sm font-semibold  rounded-r-lg`}
            style={{ border: `solid 1px ${color}` }}
          >
            {record?.name}
          </div>
        );
      },
    },
    {
      title: (
        <div className="bg-[#eef0ff] text-[#75757E]  h-full py-1">المتوقع</div>
      ),
      render: (text: any, record: any) => {
        const color = getStatusStyles(record);

        return (
          <div
            className={`py-4 bg-white min-w-[150px] !pt-[15px] !border-r-0 w-full h-full text-color-primary text-sm font-semibold !border-l-[0px] border-[1px] border-solid`}
            style={{ border: `solid 1px ${color}` }}
          >
            {record?.exception}
          </div>
        );
      },
    },
    {
      title: <div className="bg-[#eef0ff] h-full py-1">الجرد الفعلي</div>,
      render: (text: any, record: any) => {
        const color = getStatusStyles(record);

        return (
          <div
            className={`py-4 bg-white min-w-[150px] !pt-[15px]  !border-r-0 w-full h-full text-color-primary text-sm font-semibold !border-l-[0px] border-[1px] border-solid`}
            style={{ border: `solid 1px ${color}` }}
          >
            {record?.Stocktaking}
          </div>
        );
      },
    },
    {
      title: <div className="bg-[#eef0ff] h-full py-1">تم بواسطة</div>,
      render: (text: any, record: any) => {
        const color = getStatusStyles(record);

        return (
          <div
            style={{ border: `solid 1px ${color}` }}
            className={`py-4 bg-white min-w-[150px] !pt-[15px] !border-r-0 w-full h-full text-color-primary text-sm font-semibold !border-l-[0px] border-[1px] border-solid`}
          >
            {record?.teamMember}
          </div>
        );
      },
    },
    {
      title: <div className="bg-[#eef0ff] h-full py-1"> الفرق</div>,
      render: (text: any, record: any) => {
        const color = getStatusStyles(record);

        return (
          <div
            style={{ border: `solid 1px ${color}`, color }}
            className={`py-4 bg-white min-w-[150px] !pt-[15px]  !border-r-0 w-full h-full text-color-primary text-sm font-semibold !border-l-[0px] border-[1px] border-solid`}
          >
            {record?.dif}
          </div>
        );
      },
    },
    {
      title: <div className="bg-[#eef0ff] h-full py-1">التكلفة</div>,
      render: (text: any, record: any) => {
        const color = getStatusStyles(record);
        return (
          <div
            style={{ border: `solid 1px ${color}`, color }}
            className={`py-4 bg-white min-w-[150px] !pt-[15px] w-full h-full text-color-primary text-sm font-semibold !border-r-[0px] border-[1px] border-solid rounded-l-lg`}
          >
            <span>{record?.price}</span>
            <small className="font-semibold text-[10px]">ريال سعودي</small>
          </div>
        );
      },
    },
  ];
  return (
    <div className="bg-[#EEF0FF] px-6 py-4 pb-8 rounded-lg stocking">
      <div className="mb-8">
        <span className="flex items-center mb-6 text-center">
          <IoIosArrowForward className="text-[#75757E] mt-1" />
          <span>جرد المخزون</span>
        </span>
        <h4 className="text-color-primary text-2xl font-semibold mb-4">
          جرد شهر ديسمبر
        </h4>
        <p className="text-[#75757E] font-normal text-base">معلومات الجرد</p>
      </div>
      <div className="bg-white p-4 rounded-lg flex justify-between text-sm max-lg:grid max-lg:grid-cols-2">
        <div className=" max-lg:order-2 max-lg:col-span-2">
          <div className=" flex max-lg:grid max-lg:grid-cols-2 items-center lg:gap-4 mb-4 max-lg:text-sm">
            <div className="text-color-primary py-3 px-2">
              <span className="mx-1">بداية الجرد:</span>
              <span>الثلاثاء 6 ديسمبر 2023</span>
            </div>
            <div className="text-color-primary py-3 px-2">
              <span className="mx-1">نهاية الجرد:</span>
              <span>الثلاثاء 6 ديسمبر 2023</span>
            </div>
            <div className="text-black py-3 px-2">
              <span className="mx-1">تم الجرد بواسطة</span>:
              <span>هنا احمد</span>
            </div>
            <div className="text-black py-3 px-2">
              <span className="mx-1">تم المراجعة بواسطة</span>:
              <span>هنا احمد</span>
            </div>
          </div>
          <div className="mb-4">
            <span className="text-[#75757E]">الفروع : </span>
            <span>نور مشروع الرياض - نور مشروع جدة - نور مشروع الخبر</span>
          </div>
          <div>
            <span className="text-[#75757E]">الوصف : </span>
            <span>....</span>
          </div>
        </div>
        <div className="flex max-lg:order-1 items-center text-sm justify-center h-[44px] w-[140px] gap-2 max-lg:col-span-2 border-[#479821] border-solid border-[1px] rounded-lg">
          <div className=" bg-[#479821] w-2 h-2 rounded-full max-lg:m-1 max-lg:mx-2" />
          <div className="text-[#479821] px-8">تمت</div>
        </div>
      </div>
      <AntTable
        tableColumns={columns}
        tableData={data || []}
        hideArrowExpand
        isLoading={false}
      />
    </div>
  );
};

export default StocktakingDetails;
